export const customStyle = {
    iconStyle: { fontSize:'1.25rem', fontWeight:600, color: '#333' },
    iconSmall: { fontSize:'12px', fontWeight:600, color: '#333' },
    iconMedium: { fontSize:'20px', fontWeight:600, color: '#333' },
    iconLarge: { fontSize:'25px', fontWeight:600, color: '#333' },
    headStyle: { fontSize:'1.25rem', lineHeight:1.5, fontWeight: 600, color: '#666', fontFamily: 'Times New Roman", Times, serif' },
    cardHeadSmall: { fontSize:'1.0rem', lineHeight:1.5, fontWeight: 600, color: '#666', fontFamily: 'Times New Roman", Times, serif' },
    cardBodySmall: { fontSize:'14px', fontWeight: 600, color: '#666', fontFamily: 'Times New Roman", Times, serif' },
    shortenText: {maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}
}